var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0037 13.3187C15.8734 13.3187 20 8.49933 20 7.00212C20 5.50491 15.851 0.685547 10.0037 0.685547C4.20857 0.685547 0 5.50491 0 7.00212C0 8.49933 4.17877 13.3187 10.0037 13.3187ZM10.0037 12.3876C4.93855 12.3876 1.02793 8.09709 1.02793 7.00212C1.02793 6.01888 4.93855 1.61665 10.0037 1.61665C15.0615 1.61665 18.9795 6.01888 18.9795 7.00212C18.9795 8.09709 15.0615 12.3876 10.0037 12.3876ZM10.0037 11.166C12.3054 11.166 14.1825 9.274 14.1825 7.00212C14.1825 4.6781 12.3054 2.83825 10.0037 2.83825C7.6797 2.83825 5.81006 4.6781 5.8175 7.00212C5.8324 9.274 7.6797 11.166 10.0037 11.166ZM10.0112 8.328C9.26629 8.328 8.66294 7.7321 8.66294 7.00212C8.66294 6.26469 9.26629 5.67624 10.0112 5.67624C10.7412 5.67624 11.3445 6.26469 11.3445 7.00212C11.3445 7.7321 10.7412 8.328 10.0112 8.328Z",
    fill: "#282829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.4bd33c73f245f087a6960b93034a1d6c.svg";
export { ForwardRef as ReactComponent };